import { Box, Grid } from "@mui/material";
import { Mensaje } from "../../types";
import MessageCard from "./MessageCardDesktop";

interface MessageListProps {
    messages: Mensaje[]
}

const MessageCardListDesktop = ({ messages }: MessageListProps) => {

    return (
        <Box>
            <Grid container spacing={3}>
                {
                    messages.map((message, index) => (
                        <Grid item key={index} xs={12} sm={6} md={4} xl={3}>
                            <MessageCard
                                message={message}
                            />
                        </Grid>
                    ))
                }
            </Grid>
        </Box>
    )
}

export default MessageCardListDesktop
